module.exports = __webpack_public_path__ + "static/logo_agau-6512bf3545df32295978bceaee0e697a.png";